export const CHECKOUT_BREAKDOWN = "Checkout breakdown";
export const EXPERIENCE_TOTAL = "Total";
export const TAXES_AND_FEES_INCLUDED =
  "Price is inclusive of taxes. It also includes any fees that are covered as part of the booking.";
